// eslint-disable-next-line no-shadow
enum Client {
  KIDBIZ = 'KIDBIZ',
  SMARTY_ANTS = 'SA',
}
export default Client;
